
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 176 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M150.42 9.915v13.806h4.413v-9.204h16.138v9.204h4.412V9.915H150.42zm3.908-4.475h17.021c2.395-.442 4.097-2.585 4.602-4.602h-26.224c.504 2.017 2.269 4.097 4.601 4.602zm-17.335 18.28c2.206-.945 3.404-2.584 3.908-4.475h-19.857V.901h-4.476v22.82h20.425zM83.473 5.378h15.76c2.395-.694 4.349-2.522 4.853-4.476H79.123v13.49h20.424v4.728H83.536c-2.522.694-4.665 2.396-5.737 4.602h26.161V9.915H83.536l-.064-4.538zM44.64 5.44h17.02c2.396-.442 4.162-2.585 4.603-4.602H39.975c.505 2.017 2.27 4.097 4.665 4.602zm0 9.014h17.02c2.396-.441 4.162-2.584 4.603-4.602H39.975c.505 2.018 2.27 4.098 4.665 4.602zm0 9.267h17.02c2.396-.441 4.162-2.585 4.603-4.602H39.975c.505 2.017 2.27 4.16 4.665 4.602zM.324.896c.504 2.017 2.27 4.034 4.602 4.539h7.186l.379.126v18.092h4.475V5.561l.378-.126h7.187c2.396-.63 4.098-2.522 4.602-4.54V.834L.324.896z","fill":"#fff"}})])
          )
        }
      }
    